import axios from 'axios';

export const getPptAddLayout = async () => {
    try {
        const responseData: any = await axios({
            method: 'POST',
            url: '/v2/mall/marketing/layout',
            data: {
                language: 'zh-CN',
                layout: [
                    'pptaddtitle',
                    'pptaddoutline',
                    'pptaddsection',
                    'pptaddcontent',
                    'pptaddend',
                ],
            },
        });
        const { data } = responseData;
        if (data.retcode !== 0) {
            throw new Error('getPptAddLayout error: ', data);
        }
        return data.result.pairs.map((pair: { data: string; }) => JSON.parse(pair.data));
    } catch (err) {
        console.error('getPptAddLayout error: ', err);
    }
};

export const getPptTemplate = async () => {
    try {
        const responseData: any = await axios({
            method: 'POST',
            url: '/v2/mall/marketing/layout',
            data: {
                language: 'zh-CN',
                layout: [
                    'newslide',
                ],
            },
        });
        const { data } = responseData;
        if (data.retcode !== 0) {
            throw new Error('getPptAddLayout error: ', data);
        }
        return data.result.pairs.map((pair: { data: string; }) => JSON.parse(pair.data));
    } catch (err) {
        console.error('getPptAddLayout error: ', err);
    }
};

export const getPptTemplateDetail = async (topicIds) => {
    try {
        const responseData: any = await axios({
            method: 'POST',
            url: '/v2/mall/marketing/topics_detail',
            data: {
                limits: topicIds.map(topicId => ({ id: topicId, limit: 9999, offset: 0 })),
            },
        });
        const { data } = responseData;

        if (data.retcode !== 0) {
            throw new Error('getPptAddItems error: ', data);
        }
        return sortTopic(data.result.detail, topicIds);
    } catch (err) {
        console.error('getPptAddItems error: ', err);
    }
};

export const getPptAddItems = async (topicIds) => {
    try {
        const responseData: any = await axios({
            method: 'POST',
            url: '/v2/mall/marketing/topics_detail',
            data: {
                limits: topicIds.map(topicId => ({ id: topicId, limit: 9, offset: 0 })),
            },
        });
        const { data } = responseData;

        if (data.retcode !== 0) {
            throw new Error('getPptAddItems error: ', data);
        }
        return sortTopic(data.result.detail, topicIds);
    } catch (err) {
        console.error('getPptAddItems error: ', err);
    }
};

// 后端范围的topic顺序和Items顺序都是无序的，前端随便排个序保证显示一致
const sortTopic = (topicDataArr, topicIdArr) => {
    topicDataArr.sort((a, b) => topicIdArr.
        indexOf(a.topic.id) - topicIdArr.indexOf(b.topic.id));
    return topicDataArr;
};
